<template>
  <div class="container mt-4">
    <h1 class="text-center">About the Authors</h1>
    <div class="row">
      <ul>
        <li>
          <a href="https://pubmed.ncbi.nlm.nih.gov/?term=Zhorov+BS&cauthor_id=35207150"
             class="text-decoration-none"> Boris S. Zhorov</a>, PhD, DSc. Professor Emeritus, McMaster
          University, Hamilton, Ontario,
          Canada; Principal Scientist, Sechenov Institute of Evolutionary Physiology and Biochemistry,
          Russian Academy of Sciences, St. Petersburg
        </li>
        <li>
          <a href="https://pubmed.ncbi.nlm.nih.gov/?term=Tikhonov+DB&cauthor_id=35207150"
             class="text-decoration-none"> Denis B. Tikhonov </a>, PhD, DSc. Head of Laboratory of Biophysics
          of Synaptic Processes. Sechenov
          Institute of Evolutionary Physiology and Biochemistry, Russian Academy of Sciences, St.
          Petersburg
        </li>
        <li>
          <a href="https://pubmed.ncbi.nlm.nih.gov/?term=Korkosh+VS&cauthor_id=25156117"
             class="text-decoration-none">Viacheslav S. Korkosh</a>, PhD. Senior Scientist, Sechenov Institute
          of Evolutionary Physiology and
          Biochemistry, Russian Academy of Sciences, St. Petersburg
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

